@if (state$ | async; as state) {
<div class="page vacation">
  <h1 class="c-h1">{{ 'PERSONAL_DATA.HOLIDAYS.title' | translate }}</h1>

  <div class="vacation-intro">
    <myabvv-introduction [introduction]="'PERSONAL_DATA.HOLIDAYS.info_1' | translate"></myabvv-introduction>
  </div>

  <myabvv-alert [condition]="state.error" [message]="'USER_FEEDBACK.error_occurred'" [type]="'error'"></myabvv-alert>

  @if (state.loading) {
    <myabvv-loader [message]="'GENERAL.busy_loading' | translate"></myabvv-loader>
  }

  @if (!state.loading && !state.error) {
    <!-- Vacation Data Card -->
    <section class="vacation-card">
      <div class="vacation-card__header">
        <div class="vacation-card__icon">
          <i class="fa fa-umbrella-beach"></i>
        </div>
        <h3 class="vacation-card__title">{{ 'PERSONAL_DATA.HOLIDAYS.overview' | translate }} {{ currentYear }}</h3>
      </div>

      <div class="vacation-card__content">
        <div class="vacation-stat">
          <div class="vacation-stat__icon vacation-stat__icon--credit">
            <i class="fa fa-calendar-plus"></i>
          </div>
          <div class="vacation-stat__info">
            <span class="vacation-stat__label">{{ 'PERSONAL_DATA.HOLIDAYS.credit' | translate }}</span>
            <span class="vacation-stat__value">
              {{ state.data?.employerHolidayCredit ?? 0 }}
              <span class="vacation-stat__unit">{{ 'UNITS.days' | translate }}</span>
            </span>
          </div>
        </div>

        <div class="vacation-stat">
          <div class="vacation-stat__icon vacation-stat__icon--balance">
            <i class="fa fa-calendar-check"></i>
          </div>
          <div class="vacation-stat__info">
            <span class="vacation-stat__label">{{ 'PERSONAL_DATA.HOLIDAYS.balance' | translate }}</span>
            <span class="vacation-stat__value">
              {{ state.data?.employerHolidayBalance ?? 0 }}
              <span class="vacation-stat__unit">{{ 'UNITS.days' | translate }}</span>
            </span>
          </div>
        </div>

        <!-- Visual Progress -->
        @if (state.data && state.data.employerHolidayCredit > 0) {
          <div class="vacation-progress">
            <div class="vacation-progress__bar">
              <div class="vacation-progress__fill" [style.width.%]="getUsedPercentage(state.data)"></div>
            </div>
            <div class="vacation-progress__labels">
              <span>{{ getUsedDays(state.data) }} {{ 'PERSONAL_DATA.HOLIDAYS.days_used' | translate }}</span>
              <span>{{ state.data.employerHolidayBalance }} {{ 'PERSONAL_DATA.HOLIDAYS.days_remaining' | translate }}</span>
            </div>
          </div>
        }
      </div>
    </section>

    <!-- Warning Note -->
    <div class="vacation-note">
      <i class="fa fa-info-circle vacation-note__icon"></i>
      <p class="vacation-note__text">
        <strong>{{ 'GENERAL.warning_caps' | translate }}:</strong> {{ 'PERSONAL_DATA.HOLIDAYS.info_2' | translate }}
      </p>
    </div>

    <!-- General Information Section -->
    <section class="vacation-info">
      <h2 class="vacation-info__title">
        <i class="fa fa-question-circle"></i>
        {{ 'PERSONAL_DATA.HOLIDAYS.general_information' | translate }}
      </h2>

      <div class="vacation-info__content">
        <div class="vacation-info__item">
          <div class="vacation-info__item-icon">
            <i class="fa fa-briefcase"></i>
          </div>
          <p>{{ 'PERSONAL_DATA.HOLIDAYS.info_3' | translate }} {{ 'PERSONAL_DATA.HOLIDAYS.info_4' | translate }}</p>
        </div>

        <div class="vacation-info__item">
          <div class="vacation-info__item-icon">
            <i class="fa fa-edit"></i>
          </div>
          <p>{{ 'PERSONAL_DATA.HOLIDAYS.info_5' | translate }}</p>
        </div>

        <div class="vacation-info__item">
          <div class="vacation-info__item-icon">
            <i class="fa fa-calculator"></i>
          </div>
          <p>{{ 'PERSONAL_DATA.HOLIDAYS.info_6' | translate }}</p>
        </div>

        <div class="vacation-info__item">
          <div class="vacation-info__item-icon">
            <i class="fa fa-exclamation-triangle"></i>
          </div>
          <p>{{ 'PERSONAL_DATA.HOLIDAYS.info_7' | translate }}</p>
        </div>

        <div class="vacation-info__item">
          <div class="vacation-info__item-icon">
            <i class="fa fa-phone"></i>
          </div>
          <p>{{ 'PERSONAL_DATA.HOLIDAYS.info_8' | translate }}</p>
        </div>
      </div>
    </section>
  }
</div>
}
